export const getGenerateSSOTokenUrl = () => 'public/onboarding_forms/generate_sso_token';

export const getPublicDefaultSentimentKeywordsUrl = () => 'public/onboarding_forms/default_keywords';

export const getPublicGenerateSentimentKeywordsUrl = () => 'public/onboarding_forms/generate_keywords';
